import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { post } from "../../services/api";
import { toast } from "react-toastify";

function CancelWithdrawalModal({
  onClose,
  withdrawalId,
  refreshOnSubmitSuccess,
}) {
  const token = localStorage.getItem("token");
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const saveWithdrawalConfirmation = async (data) => {
    setIsLoading(true);
    const formData = {
      withdrawalId: withdrawalId,
      reason: data.reason,
    };

    try {
      const response = await post(
        `Withdrawal/CancelWithdrawalRequestById?withdrawlId=${withdrawalId}&reason=${data.reason}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        onClose();
        refreshOnSubmitSuccess();
      } else {
        toast.error("Failed to submit.");
      }
    } catch (error) {
      console.error("Error saving:", error);
      toast.error("An error occurred while saving.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">Cancel Withdrawal</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(saveWithdrawalConfirmation)}>
                <input
                  type="hidden"
                  value={withdrawalId}
                  {...register("withdrawalId")}
                />

                <div className="mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Reason</label>
                    <textarea
                      className="form-control"
                      {...register("reason", {
                        required: "Reason is required",
                      })}
                    ></textarea>
                    {errors.reason && (
                      <small className="text-danger">
                        {errors.reason.message}
                      </small>
                    )}
                  </div>
                </div>

                <div className="d-flex gap-2 justify-content-end">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default CancelWithdrawalModal;
